export default __webpack_public_path__ + "dc2c3c5143afd13f401224bedc8f6b07.svg";